document.addEventListener('DOMContentLoaded', function() {
  // We'll initialize the cart drawer fix, but with a delay to ensure all elements are loaded
  setTimeout(initCartDrawerFix, 100); // Small initial delay
  
  // Also set up a more robust initialization approach
  function initCartDrawerFix() {
    // Handle cart drawer functionality
    class CartDrawerFix {
      constructor() {
        // Try to find elements, with fallbacks
        this.drawer = document.querySelector('cart-drawer');
        this.cartIconBubble = document.querySelector('#cart-icon-bubble');
        this.cartItems = null;
        this.cartItemCount = 0;
        
        // Track modal cart additions to defer drawer opening
        this.pendingCartAddition = false;
        this.modalCloseDetected = false;
        
        // Find forms and buttons - but don't fail if they're not found yet
        this.addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
        this.stickyAddToCartForm = document.getElementById('add-to-cart-form');
        this.stickyAddToCartButton = document.querySelector('button[form="add-to-cart-form"]');
        this.mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]');
        
        if (!this.drawer) {
          console.warn('Cart drawer element not found, will retry');
          // Schedule a retry
          setTimeout(() => this.retryInitialization(), 500);
          return;
        }
        
        // Store current cart state
        this.getCartState();
        
        // Set up event listeners for the elements we already found
        this.setupEventListeners();
        
        // Fix the cart items update method
        this.fixCartItemsUpdateMethod();
        
        // Handle error messages
        this.hideErrorMessages();
        
        // Set up mutation observer for dynamic content
        this.setupMutationObserver();
        
        // Monitor quick-add-modal elements
        this.monitorQuickAddModals();
        
        // Setup close drawer on click outside
        this.setupCloseDrawerOnClickOutside();
        
        // Set up retries for finding elements that might not be loaded yet
        this.setupRetryForMissingElements();
        
        // Set up the universal click handler for add-to-cart buttons
        this.setupUniversalAddToCartHandler();
        
        // Setup click outside modal handler to ensure cart drawer opens
        this.setupClickOutsideModalHandler();
        
        // Setup related products handlers
        this.setupRelatedProductsHandlers();
        
        // Monitor modal display state changes
        this.setupModalStateObserver();
        
        console.log('Cart drawer fix initialized successfully');
      }
      
      retryInitialization() {
        // Try to find the drawer again
        this.drawer = document.querySelector('cart-drawer');
        
        if (!this.drawer) {
          // Still not found, schedule another retry with increasing delay
          console.warn('Cart drawer still not found, will retry again');
          setTimeout(() => this.retryInitialization(), 1000);
          return;
        }
        
        // Initialize now that we have the drawer
        console.log('Cart drawer found on retry, initializing');
        
        // Store current cart state
        this.getCartState();
        
        // Set up event listeners
        this.setupEventListeners();
        
        // Fix the cart items update method
        this.fixCartItemsUpdateMethod();
        
        // Handle error messages
        this.hideErrorMessages();
        
        // Set up mutation observer for dynamic content
        this.setupMutationObserver();
        
        // Monitor quick-add-modal elements
        this.monitorQuickAddModals();
        
        // Setup close drawer on click outside
        this.setupCloseDrawerOnClickOutside();
        
        // Set up retries for finding elements that might not be loaded yet
        this.setupRetryForMissingElements();
        
        // Set up the universal click handler for add-to-cart buttons
        this.setupUniversalAddToCartHandler();
        
        // Setup click outside modal handler to ensure cart drawer opens
        this.setupClickOutsideModalHandler();
        
        // Setup related products handlers
        this.setupRelatedProductsHandlers();
        
        // Monitor modal display state changes
        this.setupModalStateObserver();
      }
      
      setupRetryForMissingElements() {
        // Check specifically for sticky add-to-cart elements
        if (!this.stickyAddToCartForm || !this.stickyAddToCartButton) {
          console.log('Sticky add-to-cart not found, setting up observer to watch for it');
          
          // Set up a mutation observer to detect when the sticky element appears
          const stickyObserver = new MutationObserver((mutations, observer) => {
            // Check if sticky elements now exist
            const stickyForm = document.getElementById('add-to-cart-form');
            const stickyButton = document.querySelector('button[form="add-to-cart-form"]');
            
            if (stickyForm && stickyButton) {
              console.log('Sticky add-to-cart found, attaching handlers');
              
              // Store the references
              this.stickyAddToCartForm = stickyForm;
              this.stickyAddToCartButton = stickyButton;
              
              // Set up the sticky button handler
              this.setupStickyAddToCartButton();
              
              // We can stop observing now
              observer.disconnect();
            }
          });
          
          // Start observing the body for the sticky elements to appear
          stickyObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
          
          // Also try with a delayed check
          setTimeout(() => {
            const stickyForm = document.getElementById('add-to-cart-form');
            const stickyButton = document.querySelector('button[form="add-to-cart-form"]');
            
            if (stickyForm && stickyButton && !this.stickyAddToCartForm) {
              console.log('Sticky add-to-cart found on delayed check');
              
              // Store the references
              this.stickyAddToCartForm = stickyForm;
              this.stickyAddToCartButton = stickyButton;
              
              // Set up the sticky button handler
              this.setupStickyAddToCartButton();
            }
          }, 2000); // Generous delay to catch late-loading elements
        }
        
        // Also add a scroll handler as sticky elements often appear on scroll
        window.addEventListener('scroll', () => {
          // Debounce to avoid too many checks
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(() => {
            // Check for sticky elements only if we haven't found them yet
            if (!this.stickyAddToCartForm || !this.stickyAddToCartButton) {
              const stickyForm = document.getElementById('add-to-cart-form');
              const stickyButton = document.querySelector('button[form="add-to-cart-form"]');
              
              if (stickyForm && stickyButton) {
                console.log('Sticky add-to-cart found on scroll');
                
                // Store the references
                this.stickyAddToCartForm = stickyForm;
                this.stickyAddToCartButton = stickyButton;
                
                // Set up the sticky button handler
                this.setupStickyAddToCartButton();
              }
            }
          }, 200);
        }, { passive: true });
      }
      
      setupCloseDrawerOnClickOutside() {
        // Add click event listener to the document
        document.addEventListener('click', (event) => {
          // Only proceed if the drawer is open
          if (!this.drawer || !this.isDrawerOpen()) return;
          
          // Check if click was on the overlay (drawer underlay)
          const drawerOverlay = this.drawer.querySelector('.drawer__overlay');
          if (drawerOverlay && drawerOverlay.contains(event.target)) {
            this.closeDrawer();
            return;
          }
          
          // If the click is outside the drawer content (on the overlay part)
          const drawerContent = this.drawer.querySelector('.drawer__content');
          if (drawerContent && !drawerContent.contains(event.target) && !event.target.closest('button[form]')) {
            // Close the drawer if the click is outside the content area
            // and not on a form button (which might be for adding to cart)
            this.closeDrawer();
          }
        });
      }
      
      setupClickOutsideModalHandler() {
        // First approach: Direct event listener on document
        document.addEventListener('click', (event) => {
          // Find any open modals
          const openModal = document.querySelector('quick-add-modal[open], product-modal[open], modal-dialog[open]');
          if (!openModal) return; // No open modal
          
          // Find the modal content element
          const modalContent = openModal.querySelector('.modal__content, .quick-add-modal__content, .product-media-modal__content');
          const modalOverlay = openModal.querySelector('.overlay, .drawer__overlay, .modal__overlay, quick-add-modal__overlay');
          
          // If click was on overlay or outside the modal content
          if ((modalOverlay && modalOverlay.contains(event.target)) || 
              (modalContent && !modalContent.contains(event.target) && 
               !event.target.closest('[id^="ModalClose-"], .modal__toggle, .product-media-modal__toggle'))) {
            
            console.log('Click outside modal detected via document click');
            
            // Store the pending cart status before closing
            const hasPendingAddition = this.pendingCartAddition;
            
            // The next time the modal is closed, we'll need to open the drawer
            if (hasPendingAddition) {
              console.log('Setting up to open drawer after modal close');
              this.modalCloseDetected = true;
              
              // Set timeout to open drawer after modal has closed
              setTimeout(() => {
                // Check if modal has been closed and we still have a pending addition
                const modalStillOpen = !!document.querySelector('quick-add-modal[open], product-modal[open], modal-dialog[open]');
                if (!modalStillOpen && this.pendingCartAddition) {
                  console.log('Opening drawer after click outside modal');
                  this.openDrawer();
                  this.pendingCartAddition = false;
                  this.modalCloseDetected = false;
                }
              }, 300);
            }
          }
        });
        
        // Second approach: Direct listeners on modal overlays
        const addOverlayListeners = () => {
          const overlays = document.querySelectorAll('.overlay, .drawer__overlay, .modal__overlay, .quick-add-modal__overlay');
          overlays.forEach(overlay => {
            if (!overlay.dataset.listenerAdded) {
              overlay.dataset.listenerAdded = 'true';
              
              overlay.addEventListener('click', () => {
                console.log('Modal overlay clicked');
                if (this.pendingCartAddition) {
                  console.log('Will open drawer after modal closes from overlay click');
                  // Set flag to open drawer after modal closes
                  this.modalCloseDetected = true;
                  
                  // Also set a timeout as backup
                  setTimeout(() => {
                    if (this.pendingCartAddition && this.modalCloseDetected) {
                      console.log('Opening drawer after modal overlay click (timeout)');
                      this.openDrawer();
                      this.pendingCartAddition = false;
                      this.modalCloseDetected = false;
                    }
                  }, 500);
                }
              });
            }
          });
        };
        
        // Add listeners now and also set up an observer to catch dynamically added overlays
        addOverlayListeners();
        
        // Create an observer to detect when overlays are added to the DOM
        const overlayObserver = new MutationObserver((mutations) => {
          let shouldAddListeners = false;
          
          mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && 
                    (node.matches && node.matches('.overlay, .drawer__overlay, .modal__overlay, .quick-add-modal__overlay') ||
                     node.querySelector && node.querySelector('.overlay, .drawer__overlay, .modal__overlay, .quick-add-modal__overlay'))) {
                  shouldAddListeners = true;
                }
              });
            }
          });
          
          if (shouldAddListeners) {
            addOverlayListeners();
          }
        });
        
        overlayObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
        
        // Listen for modalClosed event (for when X button is clicked)
        document.addEventListener('modalClosed', (event) => {
          console.log('Modal closed event detected');
          
          // Check if we have a pending cart addition
          if (this.pendingCartAddition) {
            console.log('Opening cart drawer after modal close event');
            setTimeout(() => {
              this.openDrawer();
              this.pendingCartAddition = false;
              this.modalCloseDetected = false;
            }, 300);
          }
        });
      }
      
      // New method to observe modal state changes
      setupModalStateObserver() {
        // Watch for attribute changes on modals (like removing the 'open' attribute)
        const modalObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && 
                (mutation.attributeName === 'open' || 
                 mutation.attributeName === 'aria-hidden' || 
                 mutation.attributeName === 'class')) {
                
              const modal = mutation.target;
              const wasOpen = modal.dataset.wasOpen === 'true';
              
              // Check if modal is now closed but was previously open
              const isClosed = !(modal.hasAttribute('open') || 
                               modal.getAttribute('aria-hidden') === 'false' ||
                               modal.classList.contains('active'));
                
              if (wasOpen && isClosed) {
                console.log('Modal closed detected via attribute change');
                
                // Check if we have a pending addition
                if (this.pendingCartAddition) {
                  console.log('Opening drawer after modal attribute change');
                  setTimeout(() => {
                    this.openDrawer();
                    this.pendingCartAddition = false;
                    this.modalCloseDetected = false;
                  }, 300);
                }
              }
              
              // Update the current state
              modal.dataset.wasOpen = !isClosed;
            }
          });
        });
        
        // Start observing modals
        const startObservingModals = () => {
          const modals = document.querySelectorAll('quick-add-modal, product-modal, modal-dialog');
          modals.forEach(modal => {
            // Skip if already observing
            if (modal.dataset.stateObserved === 'true') return;
            modal.dataset.stateObserved = 'true';
            
            // Track if modal is currently open
            const isOpen = modal.hasAttribute('open') || 
                         modal.getAttribute('aria-hidden') === 'false' ||
                         modal.classList.contains('active');
            modal.dataset.wasOpen = isOpen;
            
            // Observe changes
            modalObserver.observe(modal, {
              attributes: true,
              attributeFilter: ['open', 'aria-hidden', 'class']
            });
          });
        };
        
        // Initial observation
        startObservingModals();
        
        // Set up observer for new modals
        const newModalObserver = new MutationObserver((mutations) => {
          let newModalsFound = false;
          
          mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && 
                    (node.tagName === 'QUICK-ADD-MODAL' || 
                     node.tagName === 'PRODUCT-MODAL' ||
                     node.tagName === 'MODAL-DIALOG' ||
                     (node.querySelector && 
                      node.querySelector('quick-add-modal, product-modal, modal-dialog')))) {
                  newModalsFound = true;
                }
              });
            }
          });
          
          if (newModalsFound) {
            startObservingModals();
          }
        });
        
        newModalObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      setupUniversalAddToCartHandler() {
        // Use event delegation to catch all add-to-cart actions throughout the site
        document.addEventListener('click', (event) => {
          // Identify add-to-cart buttons by their attributes
          const addToCartButton = event.target.closest('button[type="submit"][form^="product-form"], button[form^="quick-add"], button[name="add"], button[form="add-to-cart-form"]');
          
          if (addToCartButton && !event.defaultPrevented) {
            event.preventDefault();
            
            console.log('Universal handler: Add to cart button clicked', addToCartButton);
            
            // Find the form this button is associated with
            const formId = addToCartButton.getAttribute('form');
            const form = formId ? document.getElementById(formId) : addToCartButton.closest('form');
            
            if (form && form.action && form.action.includes('/cart/add')) {
              // Check if this is from within a modal
              const isFromModal = !!addToCartButton.closest('quick-add-modal, product-modal, modal-dialog');
              
              // Handle the add to cart action
              this.handleAddToCart(event, form, null, isFromModal);
            }
          }
        });
        
        // Also catch form submissions
        document.addEventListener('submit', (event) => {
          const form = event.target;
          
          if (form.action && form.action.includes('/cart/add') && !event.defaultPrevented) {
            event.preventDefault();
            console.log('Universal handler: Add to cart form submitted', form);
            
            // Check if this is from within a modal
            const isFromModal = !!form.closest('quick-add-modal, product-modal, modal-dialog');
            
            this.handleAddToCart(event, form, null, isFromModal);
          }
        });
      }
      
      // Setup handlers specifically for the related products section
      setupRelatedProductsHandlers() {
        // Use MutationObserver to detect when related products are loaded
        const observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.addedNodes && mutation.addedNodes.length) {
              mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Element node
                  // Look for the related products section or items within it
                  const relatedSection = node.classList && node.classList.contains('related-products') ? 
                                          node : node.querySelector('.related-products');
                  
                  if (relatedSection) {
                    console.log('Related products section detected, setting up handlers');
                    
                    // Find all add-to-cart forms within the related products
                    const forms = relatedSection.querySelectorAll('form[action*="/cart/add"]');
                    forms.forEach(form => {
                      if (!form.dataset.handlerApplied) {
                        form.dataset.handlerApplied = 'true';
                        
                        // Setup form submission handler
                        form.addEventListener('submit', (event) => {
                          event.preventDefault();
                          this.handleAddToCart(event, form);
                        });
                        
                        // Also handle button clicks directly
                        const submitButton = form.querySelector('[type="submit"]');
                        if (submitButton) {
                          submitButton.addEventListener('click', (event) => {
                            event.preventDefault();
                            this.handleAddToCart(event, form);
                          });
                        }
                      }
                    });
                  }
                }
              });
            }
          });
        });
        
        // Start observing the document for related products
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
        
        // Also immediately check for already loaded related products
        const relatedProducts = document.querySelector('.related-products');
        if (relatedProducts) {
          const forms = relatedProducts.querySelectorAll('form[action*="/cart/add"]');
          forms.forEach(form => {
            if (!form.dataset.handlerApplied) {
              form.dataset.handlerApplied = 'true';
              
              form.addEventListener('submit', (event) => {
                event.preventDefault();
                this.handleAddToCart(event, form);
              });
              
              const submitButton = form.querySelector('[type="submit"]');
              if (submitButton) {
                submitButton.addEventListener('click', (event) => {
                  event.preventDefault();
                  this.handleAddToCart(event, form);
                });
              }
            }
          });
        }
      }
      
      monitorQuickAddModals() {
        // Find any existing quick-add-modal elements
        const quickAddModals = document.querySelectorAll('quick-add-modal');
        quickAddModals.forEach(modal => this.handleQuickAddModal(modal));
        
        // Watch for dialog close events on quick-add-modals
        document.addEventListener('click', (event) => {
          // Check if this is a close button click on a quick-add-modal
          if (event.target.closest('.product-media-modal__toggle, [id^="ModalClose-"]')) {
            const modal = event.target.closest('quick-add-modal, product-modal');
            if (modal) {
              console.log('Modal close button clicked', modal);
              
              // Check if we have a pending cart addition
              if (this.pendingCartAddition) {
                // Give a moment for the modal to close
                setTimeout(() => {
                  this.openDrawer();
                  this.pendingCartAddition = false;
                  this.modalCloseDetected = false;
                }, 300);
              }
            }
          }
          
          // Also check for clicks on the modal overlay/backdrop
          const overlay = event.target.closest('.overlay, .modal__overlay, .drawer__overlay');
          if (overlay) {
            console.log('Modal overlay clicked directly', overlay);
            
            // Check if we have a pending cart addition
            if (this.pendingCartAddition) {
              // Modal will close naturally - wait for it
              setTimeout(() => {
                this.openDrawer();
                this.pendingCartAddition = false;
                this.modalCloseDetected = false;
              }, 300);
            }
          }
        }, true); // Use capturing phase to get the event before it reaches the modal
      }
      
      handleQuickAddModal(modal) {
        if (!modal || modal.dataset.handlerApplied) return;
        modal.dataset.handlerApplied = 'true';
        
        console.log('Setting up QuickAddModal handler', modal);
        
        // Find the form inside the modal
        const modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
        if (!modalContent) return;
        
        // Add direct click handler to any modal overlay
        const modalOverlay = modal.querySelector('.overlay, .modal__overlay, .drawer__overlay');
        if (modalOverlay && !modalOverlay.dataset.clickHandlerApplied) {
          modalOverlay.dataset.clickHandlerApplied = 'true';
          modalOverlay.addEventListener('click', () => {
            console.log('Direct overlay click handler triggered');
            if (this.pendingCartAddition) {
              setTimeout(() => {
                this.openDrawer();
                this.pendingCartAddition = false;
                this.modalCloseDetected = false;
              }, 300);
            }
          });
        }
        
        // Watch for content changes in the modal
        const contentObserver = new MutationObserver(() => {
          const form = modalContent.querySelector('form[action*="/cart/add"]');
          if (form && !form.dataset.handlerApplied) {
            this.setupQuickAddModalForm(form, modal);
          }
        });
        
        // Start observing the modal content
        contentObserver.observe(modalContent, {
          childList: true,
          subtree: true
        });
        
        // Also check immediately for any existing form
        const form = modalContent.querySelector('form[action*="/cart/add"]');
        if (form) {
          this.setupQuickAddModalForm(form, modal);
        }
      }
      
      setupQuickAddModalForm(form, modal) {
        if (form.dataset.handlerApplied) return;
        form.dataset.handlerApplied = 'true';
        
        console.log('Setting up QuickAddModal form', form);
        
        // Override the form submission
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          
          // Store old cart state before we update
          const oldCartItemCount = this.cartItemCount;
          
          // Add loading state to submit button
          const submitButton = form.querySelector('[type="submit"]');
          const loadingSpinner = submitButton?.querySelector('.loading-overlay__spinner');
          
          if (submitButton) submitButton.classList.add('loading');
          if (loadingSpinner) loadingSpinner.classList.remove('hidden');
          
          // Create form data
          const formData = new FormData(form);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
          
          // Send AJAX request
          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            body: formData
          })
          .then(response => response.json())
          .then(data => {
            console.log('Product added from modal:', data);
            
            // Update our cart state
            this.getCartState();
            
            // Mark that we have a pending cart addition but don't open drawer yet
            this.pendingCartAddition = true;
            
            // Update the cart drawer content so it's ready when opened
            this.refreshCartAndRender(data, false); // Pass false to not open drawer
            
            // Hide the modal - this should trigger our modalClosed event handler
            if (modal && typeof modal.hide === 'function') {
              modal.hide();
            }
          })
          .catch(error => {
            console.error('Error adding to cart from modal:', error);
          })
          .finally(() => {
            // Reset loading state
            if (submitButton) submitButton.classList.remove('loading');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
          });
        });
      }
      
      isDrawerOpen() {
        return this.drawer.hasAttribute('open') || 
               this.drawer.classList.contains('active') || 
               this.drawer.getAttribute('aria-hidden') === 'false';
      }
      
      closeDrawer() {
        if (this.drawer) {
          // Try using the native close method first
          if (typeof this.drawer.close === 'function') {
            this.drawer.close();
          } else {
            // Fallback to manual closing
            this.drawer.classList.remove('animate', 'active');
            this.drawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('overflow-hidden');
          }
        }
      }
      
      getCartState() {
        // Get current cart state to compare later
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cart => {
            this.cartItems = cart.items;
            this.cartItemCount = cart.item_count;
          })
          .catch(error => {
            console.error('Error fetching cart state:', error);
          });
      }
      
      setupStickyAddToCartButton() {
        if (!this.stickyAddToCartButton || !this.stickyAddToCartForm) return;
        
        // Remove any existing event listeners
        this.stickyAddToCartButton.removeEventListener('click', this.stickyButtonHandler);
        
        // Create a handler function that we can reference later for removal
        this.stickyButtonHandler = (event) => {
          event.preventDefault();
          
          // Find the main form if not already found
          if (!this.mainProductForm) {
            this.mainProductForm = document.querySelector('form[data-type="add-to-cart-form"]');
          }
          
          // Instead of submitting the sticky form, we'll trigger a submission on the main form
          // but with the variant ID from the sticky form
          if (this.mainProductForm) {
            // Get the variant ID from the sticky form
            const variantId = this.stickyAddToCartForm.querySelector('[name="id"]').value;
            
            // Set this variant ID on the main form
            const mainFormIdInput = this.mainProductForm.querySelector('[name="id"]');
            if (mainFormIdInput && variantId) {
              // Save the original value to restore later
              const originalValue = mainFormIdInput.value;
              
              // Set the new value from the sticky form
              mainFormIdInput.value = variantId;
              
              // Submit the main form
              const submitEvent = new Event('submit', { bubbles: true });
              this.mainProductForm.dispatchEvent(submitEvent);
              
              // Restore the original value
              setTimeout(() => {
                mainFormIdInput.value = originalValue;
              }, 100);
            }
          } else {
            // If we can't find the main form, just submit the sticky form directly
            this.handleAddToCart(event, this.stickyAddToCartForm);
          }
        };
        
        // Add the click handler
        this.stickyAddToCartButton.addEventListener('click', this.stickyButtonHandler);
        
        console.log('Sticky add-to-cart button handler attached');
      }
      
      setupEventListeners() {
        // Handle regular add to cart forms (except sticky form)
        this.addToCartForms.forEach(form => {
          if (form.id !== 'add-to-cart-form') { // Skip the sticky form
            form.addEventListener('submit', this.handleAddToCart.bind(this));
          }
        });
        
        // Set up sticky button if available
        if (this.stickyAddToCartButton && this.stickyAddToCartForm) {
          this.setupStickyAddToCartButton();
        }
        
        // Handle cart icon clicks
        if (this.cartIconBubble) {
          this.cartIconBubble.addEventListener('click', (event) => {
            event.preventDefault();
            this.openDrawer();
          });
        }
      }
      
      setupMutationObserver() {
        // Set up a mutation observer to detect when modals are added to the DOM
        const observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach(node => {
                // Check for quick-add-modal being added
                if (node.nodeType === 1 && 
                    (node.tagName === 'QUICK-ADD-MODAL' || 
                     node.querySelector && node.querySelector('quick-add-modal'))) {
                  // Wait a moment for the modal to fully initialize
                  setTimeout(() => {
                    this.handleQuickAddModal(node.tagName === 'QUICK-ADD-MODAL' ? node : node.querySelector('quick-add-modal'));
                  }, 100);
                }
              });
            }
          });
        });
        
        // Start observing the document body
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      checkCartUpdated() {
        // Fetch current cart state
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cart => {
            // If item count has changed, cart was updated
            if (cart.item_count !== this.cartItemCount) {
              console.log('Cart was updated outside our handlers, opening drawer');
              
              // Update our stored state
              this.cartItems = cart.items;
              this.cartItemCount = cart.item_count;
              
              // Fetch the cart sections
              return fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`);
            }
          })
          .then(response => {
            if (response) return response.json();
          })
          .then(sections => {
            if (sections) {
              this.updateCartDrawer(sections);
            }
          })
          .catch(error => {
            console.error('Error checking cart updates:', error);
          });
      }
      
      // Modified to accept a fromModal parameter to defer drawer opening
      handleAddToCart(event, customForm = null, button = null, fromModal = false) {
        event.preventDefault();
        
        // Use either the form from the event or a custom form passed in
        const form = customForm || event.target;
        
        // Create form data
        const formData = new FormData(form);
        
        // Add sections for cart drawer
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        
        // Add button loading state
        const submitButton = button || customForm 
          ? customForm.querySelector('[type="submit"]') 
          : form.querySelector('[type="submit"]');
          
        const loadingSpinner = submitButton ? submitButton.querySelector('.loading-overlay__spinner') : null;
        
        if (submitButton) submitButton.classList.add('loading');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');
        
        // Send AJAX request
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Update our cart state
          this.getCartState();
          
          // If from a modal, set pendingCartAddition flag but don't open drawer yet
          if (fromModal) {
            this.pendingCartAddition = true;
            this.refreshCartAndRender(data, false); // Don't open drawer
          } else {
            // For non-modal add-to-cart, open drawer immediately
            this.refreshCartAndRender(data, true); // Open drawer
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          // Reset loading state
          if (submitButton) submitButton.classList.remove('loading');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
      }
      
      // Refreshes the cart sections and renders the updated content
      refreshCartAndRender(cartData, openDrawerAfter = true) {
        if (!cartData) return;
        
        // Determine if we need to fetch the cart data
        if (!cartData.sections || (!cartData.sections['cart-drawer'] && !cartData.sections['cart-icon-bubble'])) {
          // We don't have the proper sections, so fetch them
          fetch(`${window.Shopify.routes.root}cart.js`)
            .then(response => response.json())
            .then(cart => {
              // Update our cart state
              this.cartItems = cart.items;
              this.cartItemCount = cart.item_count;
              
              // For empty carts, we need to make sure we get the empty cart template
              const sectionsParam = cart.item_count === 0 ? 'cart-drawer,cart-icon-bubble,cart-empty-message' : 'cart-drawer,cart-icon-bubble';
              
              // Fetch the cart sections
              return fetch(`${window.Shopify.routes.root}?sections=${sectionsParam}`);
            })
            .then(response => response.json())
            .then(sections => {
              this.updateCartDrawer(sections, openDrawerAfter);
            })
            .catch(error => {
              console.error('Error fetching cart sections:', error);
            });
        } else {
          // We have the sections data, so use it directly
          this.updateCartDrawer(cartData.sections, openDrawerAfter);
        }
      }
      
      // Updates the cart drawer with the provided sections data
      updateCartDrawer(sections, openDrawerAfter = true) {
        // Update cart icon count
        if (sections['cart-icon-bubble'] && this.cartIconBubble) {
          this.cartIconBubble.innerHTML = sections['cart-icon-bubble'];
        }
        
        // Update cart drawer content
        if (sections['cart-drawer'] && this.drawer) {
          // Create a temporary div to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-drawer'];
          
          // Check if the new drawer has empty state
          const isEmptyCart = tempDiv.querySelector('.drawer__inner')?.classList.contains('is-empty');
          
          // Find the new drawer inner content
          const newInnerContent = tempDiv.querySelector('.drawer__inner');
          
          if (newInnerContent) {
            // Find the current drawer inner content
            const currentInnerContent = this.drawer.querySelector('.drawer__inner');
            
            if (currentInnerContent) {
              // Replace the inner content
              currentInnerContent.innerHTML = newInnerContent.innerHTML;
              
              // Ensure class consistency with the source
              if (isEmptyCart) {
                currentInnerContent.classList.add('is-empty');
                this.drawer.classList.add('is-empty');
              } else {
                currentInnerContent.classList.remove('is-empty');
                this.drawer.classList.remove('is-empty');
              }
            }
          } else {
            // If there's no drawer inner content, we need to replace the entire drawer HTML
            this.drawer.innerHTML = tempDiv.querySelector('cart-drawer').innerHTML;
          }
          
          // Setup quantity change and remove button listeners
          this.setupQuantityListeners();
          
          // Open the drawer only if requested
          if (openDrawerAfter) {
            this.openDrawer();
          }
        }
      }
      
      setupQuantityListeners() {
        // Add event listeners to quantity inputs
        const quantityInputs = document.querySelectorAll('.quantity__input');
        quantityInputs.forEach(input => {
          input.addEventListener('change', (event) => {
            const lineIndex = input.dataset.index;
            const newQuantity = parseInt(input.value, 10);
            
            if (lineIndex && !isNaN(newQuantity)) {
              this.updateItemQuantity(lineIndex, newQuantity);
            }
          });
        });
        
        // Add event listeners to remove buttons
        const removeButtons = document.querySelectorAll('cart-remove-button');
        removeButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            
            const lineIndex = button.dataset.index;
            if (lineIndex) {
              this.updateItemQuantity(lineIndex, 0);
            }
          });
        });
      }
      
      updateItemQuantity(lineIndex, quantity) {
        // Show loading state
        const lineItem = document.getElementById(`CartDrawer-Item-${lineIndex}`);
        if (lineItem) {
          lineItem.classList.add('loading');
        }
        
        // Create body data
        const body = JSON.stringify({
          line: lineIndex,
          quantity: quantity,
          sections: ['cart-drawer', 'cart-icon-bubble', 'cart-empty-message'],
          sections_url: window.location.pathname
        });
        
        // Send cart change request
        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        })
        .then(response => response.json())
        .then(cartData => {
          // Update our cart state
          this.getCartState();
          
          // Special handling for empty cart
          if (cartData.item_count === 0) {
            this.handleEmptyCart(cartData);
          } else {
            // Refresh cart with sections data
            this.refreshCartAndRender(cartData);
          }
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          
          // Hide loading state
          if (lineItem) {
            lineItem.classList.remove('loading');
          }
        });
      }
      
      handleEmptyCart(cartData) {
        // Fetch the empty cart template
        fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble,cart-empty-message`)
          .then(response => response.json())
          .then(sections => {
            // Update cart icon
            if (sections['cart-icon-bubble'] && this.cartIconBubble) {
              this.cartIconBubble.innerHTML = sections['cart-icon-bubble'];
            }
            
            // Update cart drawer with empty state
            if (sections['cart-drawer'] && this.drawer) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sections['cart-drawer'];
              
              // Get the empty drawer content
              const drawerContent = tempDiv.querySelector('cart-drawer');
              if (drawerContent) {
                // Replace the entire drawer content
                this.drawer.innerHTML = drawerContent.innerHTML;
                
                // Add empty class
                this.drawer.classList.add('is-empty');
                
                const innerContent = this.drawer.querySelector('.drawer__inner');
                if (innerContent) {
                  innerContent.classList.add('is-empty');
                }
              }
            }
            
            // Open the drawer to show the empty state
            this.openDrawer();
          })
          .catch(error => {
            console.error('Error handling empty cart:', error);
          });
      }
      
      openDrawer() {
        if (this.drawer && typeof this.drawer.open === 'function') {
          this.drawer.open();
        } else {
          // Fallback if the open method doesn't exist
          this.drawer.classList.add('animate', 'active');
          this.drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
        }
      }
      
      hideErrorMessages() {
        // Hide error messages with CSS
        const style = document.createElement('style');
        style.textContent = `
          #CartDrawer-CartErrors, 
          .cart-item__error,
          [id^="CartDrawer-LineItemError-"],
          .cart__errors,
          #cart-errors {
            display: none !important;
          }
        `;
        document.head.appendChild(style);
        
        // Intercept cart error events
        document.body.addEventListener('cart-error', function(event) {
          event.stopPropagation();
          return false;
        }, true);
        
        // Override cart strings to empty strings
        if (window.cartStrings) {
          window.cartStrings.error = '';
          window.cartStrings.quantityError = '';
        }
      }
      
      fixCartItemsUpdateMethod() {
        // Fix the updateQuantity method in CartItems class
        const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        
        if (cartItemsElement) {
          // Store original updateQuantity method
          const originalUpdateQuantity = cartItemsElement.updateQuantity;
          
          // Replace with fixed version
          cartItemsElement.updateQuantity = function(line, quantity, event) {
            // Call our custom quantity update instead
            const cartDrawerFix = document.cartDrawerFixInstance;
            if (cartDrawerFix) {
              cartDrawerFix.updateItemQuantity(line, quantity);
              return;
            }
            
            // Fall back to original method if our instance isn't available
            if (originalUpdateQuantity && typeof originalUpdateQuantity === 'function') {
              originalUpdateQuantity.call(this, line, quantity, event);
            }
          };
        }
      }
    }
    
    // Only initialize if not already initialized
    if (!document.cartDrawerFixInstance) {
      document.cartDrawerFixInstance = new CartDrawerFix();
      
      // Also run the quick add setup
      setupRecommendedProductButtons();
    }
  }
  
  // Handle recommended products and quick-add buttons
  function setupRecommendedProductButtons() {
    // Look for quick-add forms by their ID pattern
    const quickAddForms = document.querySelectorAll('form[id^="quick-add-"]');
    
    quickAddForms.forEach(form => {
      // Skip if already handled
      if (form.dataset.handlerApplied) return;
      form.dataset.handlerApplied = 'true';
      
      // Add custom submit handler
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        
        const submitButton = this.querySelector('[type="submit"]');
        const loadingSpinner = submitButton?.querySelector('.loading-overlay__spinner');
        
        // Show loading state
        if (submitButton) submitButton.classList.add('loading');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');
        
        // Create form data
        const formData = new FormData(this);
        
        // Add sections for cart drawer
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        
        // Send AJAX request
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Use the main CartDrawerFix instance to handle the rendering
          if (document.cartDrawerFixInstance) {
            // Update cart state
            document.cartDrawerFixInstance.getCartState();
            
            // Refresh cart - determine if this is in a modal context
            const isFromModal = !!this.closest('quick-add-modal, product-modal, modal-dialog');
            if (isFromModal) {
              // Mark pending and don't open drawer yet
              document.cartDrawerFixInstance.pendingCartAddition = true;
              document.cartDrawerFixInstance.refreshCartAndRender(data, false);
            } else {
              // Open drawer immediately for non-modal contexts
              document.cartDrawerFixInstance.refreshCartAndRender(data, true);
            }
          } else {
            // Open the cart drawer if the main handler isn't available
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          // Reset loading state
          if (submitButton) submitButton.classList.remove('loading');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
      });
    });
  }
  
  // Apply patches to the QuickAddModal component
  function patchQuickAddModal() {
    if (customElements.get('quick-add-modal')) {
      // Get the original prototype
      const QuickAddModalProto = customElements.get('quick-add-modal').prototype;
      
      // Save the original hide method
      const originalHide = QuickAddModalProto.hide;
      
      // Replace with our patched version
      QuickAddModalProto.hide = function(preventFocus = false) {
        console.log('QuickAddModal hide method called');
        
        // Trigger our custom event before the original hide
        if (document.cartDrawerFixInstance && document.cartDrawerFixInstance.pendingCartAddition) {
          console.log('Modal closing with pending cart addition');
        }
        
        // Call the original method
        originalHide.call(this, preventFocus);
        
        // Dispatch our own modalClosed event
        setTimeout(() => {
          console.log('Dispatching modalClosed event');
          const modalClosedEvent = new CustomEvent('modalClosed', {
            bubbles: true,
            detail: { 
              source: 'modal-hide',
              target: this
            }
          });
          this.dispatchEvent(modalClosedEvent);
          document.dispatchEvent(modalClosedEvent);
        }, 100);
      };
      
      console.log('QuickAddModal hide method patched successfully');
    } else {
      // Try again in a moment if the component isn't defined yet
      setTimeout(patchQuickAddModal, 500);
    }
  }
  
  // Also set up a longer window.onload handler for any late-loading elements
  window.addEventListener('load', function() {
    // Rerun initialization after window load in case elements were added late
    initCartDrawerFix();
    
    // Patch the QuickAddModal
    patchQuickAddModal();
    
    // And set up a final check after a longer delay
    setTimeout(function() {
      // Check if we already have the instance
      if (!document.cartDrawerFixInstance) {
        console.log('Final attempt to initialize cart drawer fix');
        initCartDrawerFix();
      } else if (!document.cartDrawerFixInstance.stickyAddToCartButton) {
        // We have the instance but sticky button wasn't found
        console.log('Final attempt to set up sticky add-to-cart');
        const stickyForm = document.getElementById('add-to-cart-form');
        const stickyButton = document.querySelector('button[form="add-to-cart-form"]');
        
        if (stickyForm && stickyButton) {
          document.cartDrawerFixInstance.stickyAddToCartForm = stickyForm;
          document.cartDrawerFixInstance.stickyAddToCartButton = stickyButton;
          document.cartDrawerFixInstance.setupStickyAddToCartButton();
        }
      }
    }, 3000); // Long delay to catch very late loading elements
  });
  
  // Add an event listener for when Quick-Add-Modal is closed to ensure drawer opens
  document.addEventListener('modalClosed', function(event) {
    // Check if we have a cart drawer fix instance
    if (document.cartDrawerFixInstance) {
      // Check if there's a pending cart addition
      if (document.cartDrawerFixInstance.pendingCartAddition) {
        console.log('modalClosed event detected, opening cart drawer');
        
        // Wait a bit for any animations to complete
        setTimeout(() => {
          document.cartDrawerFixInstance.openDrawer();
          document.cartDrawerFixInstance.pendingCartAddition = false;
          document.cartDrawerFixInstance.modalCloseDetected = false;
        }, 300);
      }
    }
  });
  
  // Global modal overlay click handler
  document.addEventListener('click', function(event) {
    // Check if the click is directly on a modal overlay
    if (event.target.matches('.overlay, .drawer__overlay, .modal__overlay, .quick-add-modal__overlay')) {
      console.log('Direct click on modal overlay detected by global handler');
      
      // If we have a pending cart addition
      if (document.cartDrawerFixInstance && document.cartDrawerFixInstance.pendingCartAddition) {
        // Set a slight delay to allow the modal to close naturally first
        setTimeout(() => {
          console.log('Opening drawer after overlay click via global handler');
          document.cartDrawerFixInstance.openDrawer();
          document.cartDrawerFixInstance.pendingCartAddition = false;
          document.cartDrawerFixInstance.modalCloseDetected = false;
        }, 300);
      }
    }
  }, true); // Use capturing phase to ensure we get the event first
});